"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var value_1 = require("../evaluator/value");
var type_1 = require("../types/type");
var util_1 = require("../evaluator/util");
var evaluationErrors_1 = require("../evaluator/evaluationErrors");
var utils_1 = require("./utils");
function registerMathFunctions(context) {
    var stringOrNumber = { type: "union", options: [type_1.StringType, type_1.NumberType] };
    var numberArrayParams = {
        type: "variadic",
        parameters: [{ type: "union", options: [type_1.NumberType, type_1.StringType, { type: "array", elements: stringOrNumber }] }],
        variadicParameters: { type: "union", options: [type_1.NumberType, type_1.StringType, { type: "array", elements: stringOrNumber }] },
        returns: type_1.NumberType,
    };
    context.registerFunction("abs", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [type_1.AnyType],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var input = _a[0];
            try {
                var n = util_1.coerceNumber(input);
                return value_1.Value.number(Math.abs(n));
            }
            catch (_b) {
                return value_1.Value.number(0);
            }
        },
    });
    context.registerFunction("count", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.AnyType],
            variadicParameters: type_1.AnyType,
            returns: type_1.NumberType,
        },
        invoke: function (params) {
            var numbers = coerceNumberArray(params, true);
            return value_1.Value.number(numbers.length);
        },
    });
    context.registerFunction("counta", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.AnyType],
            variadicParameters: type_1.AnyType,
            returns: type_1.NumberType,
        },
        invoke: function (params) {
            var elements = coerceElementArray(params, true);
            return value_1.Value.number(elements.length);
        },
    });
    context.registerFunction("countif", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [{ type: "union", options: [type_1.StringType, type_1.NumberType, { type: "array", elements: stringOrNumber }] }, stringOrNumber],
            returns: type_1.NumberType,
        },
        invoke: function (_a, context) {
            var params = _a[0], condition = _a[1];
            if (util_1.isNumberValue(condition)) {
                var conditionNumber_1 = util_1.coerceNumber(condition);
                var numbers = coerceNumberArray([params], true);
                var filteredNumbers = numbers.filter(function (number) { return number === conditionNumber_1; });
                return value_1.Value.number(filteredNumbers.length);
            }
            else if (util_1.isStringValue(condition)) {
                var conditionString_1 = condition.value;
                if (conditionString_1.startsWith("=")) {
                    var conditionNumber_2 = parseFloat(conditionString_1.substring(1));
                    if (isNaN(conditionNumber_2)) {
                        throw new evaluationErrors_1.NumericError();
                    }
                    var numbers = coerceNumberArray([params], true);
                    var filteredNumbers = numbers.filter(function (number) { return number === conditionNumber_2; });
                    return value_1.Value.number(filteredNumbers.length);
                }
                else if (conditionString_1.startsWith(">=")) {
                    var conditionNumber_3 = parseFloat(conditionString_1.substring(2));
                    if (isNaN(conditionNumber_3)) {
                        throw new evaluationErrors_1.NumericError();
                    }
                    var numbers = coerceNumberArray([params], true);
                    var filteredNumbers = numbers.filter(function (number) { return number >= conditionNumber_3; });
                    return value_1.Value.number(filteredNumbers.length);
                }
                else if (conditionString_1.startsWith(">")) {
                    var conditionNumber_4 = parseFloat(conditionString_1.substring(1));
                    if (isNaN(conditionNumber_4)) {
                        throw new evaluationErrors_1.NumericError();
                    }
                    var numbers = coerceNumberArray([params], true);
                    var filteredNumbers = numbers.filter(function (number) { return number > conditionNumber_4; });
                    return value_1.Value.number(filteredNumbers.length);
                }
                else if (conditionString_1.startsWith("<=")) {
                    var conditionNumber_5 = parseFloat(conditionString_1.substring(2));
                    if (isNaN(conditionNumber_5)) {
                        throw new evaluationErrors_1.NumericError();
                    }
                    var numbers = coerceNumberArray([params], true);
                    var filteredNumbers = numbers.filter(function (number) { return number <= conditionNumber_5; });
                    return value_1.Value.number(filteredNumbers.length);
                }
                else if (conditionString_1.startsWith("<")) {
                    var conditionNumber_6 = parseFloat(conditionString_1.substring(1));
                    if (isNaN(conditionNumber_6)) {
                        throw new evaluationErrors_1.NumericError();
                    }
                    var numbers = coerceNumberArray([params], true);
                    var filteredNumbers = numbers.filter(function (number) { return number < conditionNumber_6; });
                    return value_1.Value.number(filteredNumbers.length);
                }
                else if (conditionString_1.match(/(?:^|[^~])\*|(?:^|[^~])\?/g)) { // contains a '?' or '*' not preceded by a '~'
                    var strings = coerceStringArray([params], true);
                    // convert '?' & '*' not prefixed by '~' to regex wildcard
                    // cannot use simple string replacement because negative lookbehind is not supported, so we end up capturing char before the wildcard
                    var modifiedCondtionString = conditionString_1.replace(/(?:^|[^~])\*|(?:^|[^~])\?/g, function (s) {
                        if (s.endsWith("?")) {
                            // ? in excel matches a single character, which we interpret as zero or one
                            return s.substring(0, s.length - 1) + ".?";
                        }
                        else { // s.endsWidth("&")
                            // * in excel matches a sequence of characters, which we interpret as zero or more
                            return s.substring(0, s.length - 1) + ".*";
                        }
                    });
                    // convert '~' that precedes '?' or '*' with '\' to escape wildcards
                    modifiedCondtionString = modifiedCondtionString.replace(/(~(?=\?)|~(?=\*))/g, "\\");
                    var regexString_1 = new RegExp(modifiedCondtionString, "g");
                    var filteredStrings = strings.filter(function (string) { return string.match(regexString_1); });
                    return value_1.Value.number(filteredStrings.length);
                }
                else {
                    var strings = coerceStringArray([params], true);
                    // remove '~' that precedes '?' or '*' becuase of exact match comparison
                    var filteredStrings = strings.filter(function (string) { return string === conditionString_1.replace(/(~(?=\?)|~(?=\*))/g, ""); });
                    return value_1.Value.number(filteredStrings.length);
                }
            }
            return value_1.Value.number(2);
        },
    });
    context.registerFunction("countblank", {
        invokeWithASTParameters: false,
        signature: {
            type: "variadic",
            parameters: [type_1.AnyType],
            variadicParameters: type_1.AnyType,
            returns: type_1.NumberType,
        },
        invoke: function (params) {
            var elements = coerceElementArray(params, true);
            var blankElements = elements.filter(function (e) { return utils_1.isBlank(e); });
            return value_1.Value.number(blankElements.length);
        },
    });
    context.registerFunction("average", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (params) {
            var numbers = coerceNumberArray(params, true);
            var sum = numbers.reduce(function (a, b) { return a + b; }, 0);
            return value_1.Value.number(sum / numbers.length);
        },
    });
    context.registerFunction("median", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (params) {
            var numbers = coerceNumberArray(params, true);
            numbers.sort(function (a, b) { return a - b; });
            if (numbers.length % 2 === 1) {
                return value_1.Value.number(numbers[Math.floor(numbers.length / 2)]);
            }
            else {
                return value_1.Value.number((numbers[numbers.length / 2 - 1] + numbers[numbers.length / 2]) / 2);
            }
        }
    });
    context.registerFunction("mode", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (params) {
            var numbers = coerceNumberArray(params);
            var freqs = new Map();
            for (var _i = 0, numbers_1 = numbers; _i < numbers_1.length; _i++) {
                var n = numbers_1[_i];
                freqs.set(n, freqs.has(n) ? freqs.get(n) + 1 : 1);
            }
            var maxK, maxV = 0;
            freqs.forEach(function (v, k) {
                if (v > maxV) {
                    maxK = k;
                    maxV = v;
                }
            });
            return value_1.Value.number(maxK);
        },
    });
    context.registerFunction("delta", [
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber],
                returns: type_1.NumberType,
            },
            invoke: function (_a) {
                var value = _a[0];
                var num = util_1.coerceNumber(value);
                return value_1.Value.number(num === 0 ? 1 : 0);
            },
        },
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber, stringOrNumber],
                returns: type_1.NumberType,
            },
            invoke: function (_a) {
                var a = _a[0], b = _a[1];
                var numA = util_1.coerceNumber(a);
                var numB = util_1.coerceNumber(b);
                return value_1.Value.number(numA === numB ? 1 : 0);
            },
        },
    ]);
    context.registerFunction("fact", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [stringOrNumber],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var value = _a[0];
            var num = util_1.isNumberValue(value) ? value.value : util_1.isStringValue(value) ? parseFloat(value.value) : NaN;
            if (isNaN(num) || num < 0)
                throw new evaluationErrors_1.NumericError();
            var res = 1;
            for (var i = Math.floor(num); i > 1; i--) {
                res *= i;
            }
            return value_1.Value.number(res);
        },
    });
    context.registerFunction("max", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (values) {
            var numbers = coerceNumberArray(values);
            if (numbers.length === 0)
                throw new evaluationErrors_1.NotApplicableError();
            var max = numbers[0];
            for (var i = 1; i < numbers.length; i++) {
                if (numbers[i] > max)
                    max = numbers[i];
            }
            return value_1.Value.number(max);
        },
    });
    context.registerFunction("min", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (values) {
            var numbers = coerceNumberArray(values);
            if (numbers.length === 0)
                throw new evaluationErrors_1.NotApplicableError();
            var min = numbers[0];
            for (var i = 1; i < numbers.length; i++) {
                if (numbers[i] < min)
                    min = numbers[i];
            }
            return value_1.Value.number(min);
        },
    });
    context.registerFunction("sum", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (params) {
            var numbers = coerceNumberArray(params);
            return value_1.Value.number(numbers.reduce(function (a, b) { return a + b; }, 0));
        },
    });
    context.registerFunction("product", {
        invokeWithASTParameters: false,
        signature: numberArrayParams,
        invoke: function (params) {
            var numbers = coerceNumberArray(params);
            return value_1.Value.number(numbers.reduce(function (a, b) { return a * b; }, 1));
        },
    });
    context.registerFunction("mround", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [stringOrNumber, stringOrNumber],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var number = _a[0], multiple = _a[1];
            var n = util_1.coerceNumber(number);
            var m = util_1.coerceNumber(multiple);
            if (m === 0)
                return value_1.Value.number(0);
            if (n / Math.abs(n) !== m / Math.abs(m))
                throw new evaluationErrors_1.NumericError();
            // ceil because MROUND always rounds away from zero
            return value_1.Value.number(Math.ceil(n / m) * m);
        },
    });
    function registerRound(name, rounder) {
        context.registerFunction(name, {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber, stringOrNumber],
                returns: type_1.NumberType,
            },
            invoke: function (_a) {
                var number = _a[0], digits = _a[1];
                var n = util_1.coerceNumber(number);
                var d = util_1.coerceNumber(digits);
                var factor = Math.pow(10, d);
                return value_1.Value.number(rounder(n * factor) / factor);
            },
        });
    }
    registerRound("round", Math.round);
    registerRound("roundup", Math.ceil);
    registerRound("rounddown", Math.floor);
    context.registerFunction("sqrt", {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [stringOrNumber],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var value = _a[0];
            var n = util_1.coerceNumber(value);
            if (n < 0)
                throw new evaluationErrors_1.NumericError();
            return value_1.Value.number(Math.sqrt(n));
        },
    });
    context.registerFunction('rand', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            return value_1.Value.number(Math.random());
        },
    });
    context.registerFunction('randbetween', {
        invokeWithASTParameters: false,
        signature: {
            type: "fixed",
            parameters: [stringOrNumber, stringOrNumber],
            returns: type_1.NumberType,
        },
        invoke: function (_a) {
            var bottom = _a[0], top = _a[1];
            var min = Math.floor(util_1.coerceNumber(bottom));
            var range = Math.floor(util_1.coerceNumber(top)) - min;
            if (range < 0)
                throw new evaluationErrors_1.NumericError();
            return value_1.Value.number(Math.floor(Math.random() * (range + 1) + min));
        },
    });
    context.registerFunction("base", [
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber, stringOrNumber],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var number = _a[0], radix = _a[1];
                var radixNum = util_1.coerceNumber(radix);
                if (radixNum < 2 || radixNum > 36)
                    throw new evaluationErrors_1.NumericError();
                return value_1.Value.string(Math.floor(util_1.coerceNumber(number)).toString(radixNum));
            },
        },
        {
            invokeWithASTParameters: false,
            signature: {
                type: "fixed",
                parameters: [stringOrNumber, stringOrNumber, stringOrNumber],
                returns: type_1.StringType,
            },
            invoke: function (_a) {
                var number = _a[0], radix = _a[1], minLength = _a[2];
                var radixNum = util_1.coerceNumber(radix);
                if (radixNum < 2 || radixNum > 36)
                    throw new evaluationErrors_1.NumericError();
                var minLengthNum = util_1.coerceNumber(minLength);
                if (minLengthNum > 255)
                    throw new evaluationErrors_1.NumericError();
                var formatted = Math.floor(util_1.coerceNumber(number)).toString(radixNum);
                if (formatted.length < minLengthNum) {
                    formatted = "0".repeat(minLengthNum - formatted.length) + formatted;
                }
                return value_1.Value.string(formatted);
            },
        },
    ]);
}
exports.default = registerMathFunctions;
// Accepts any Value and coerces only String types and Number types into numbers
function coerceNumberArray(values, ignoreInvalid) {
    if (ignoreInvalid === void 0) { ignoreInvalid = false; }
    var numbers = [];
    var add = function (v) {
        if (ignoreInvalid) {
            try {
                numbers.push(util_1.coerceNumber(v));
            }
            catch (e) { }
        }
        else {
            numbers.push(util_1.coerceNumber(v));
        }
    };
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var v = values_1[_i];
        if (util_1.isArrayValue(v))
            v.elements.forEach(add);
        else
            add(v);
    }
    return numbers;
}
// Accepts any Value and coerces only String types into strings
function coerceStringArray(values, ignoreInvalid) {
    if (ignoreInvalid === void 0) { ignoreInvalid = false; }
    var strings = [];
    var add = function (v) {
        if (ignoreInvalid) {
            try {
                if (util_1.isStringValue(v)) {
                    strings.push(v.value);
                }
            }
            catch (e) { }
        }
        else {
            if (util_1.isStringValue(v)) {
                strings.push(v.value);
            }
        }
    };
    for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
        var v = values_2[_i];
        if (util_1.isArrayValue(v))
            v.elements.forEach(add);
        else
            add(v);
    }
    return strings;
}
// accepts any Value and flattens array
// used in 'counta' function
function coerceElementArray(values, ignoreInvalid) {
    if (ignoreInvalid === void 0) { ignoreInvalid = false; }
    var elements = [];
    var add = function (v) {
        if (ignoreInvalid) {
            try {
                elements.push(v);
            }
            catch (e) { }
        }
        else {
            elements.push(v);
        }
    };
    for (var _i = 0, values_3 = values; _i < values_3.length; _i++) {
        var v = values_3[_i];
        if (util_1.isArrayValue(v))
            v.elements.forEach(add);
        else
            add(v);
    }
    return elements;
}
//# sourceMappingURL=math.js.map